import {datadogLogs} from '@datadog/browser-logs'

export default class DataDog {
  constructor (options) {
    this.config = options.config
    this.user = options.user

    this.init()
    this.sessionId = this.generateId()
  }

  init () {
    datadogLogs.init({
      clientToken: 'pub18bbef5c0a34ad2f123a47e1b6261b8f',
      site: 'datadoghq.com',
      forwardErrorsToLogs: false,
      service: 'booking-engine-frontend',
      env: this.config.datadogEnvironment,
    })
    datadogLogs.addLoggerGlobalContext('host', 'booking-engine')
    datadogLogs.addLoggerGlobalContext('originalReferrer', JSON.parse(localStorage.getItem('originalReferrer') || '{}')[document.referrer])
  }

  generateId () {
    return `${this.config.sellingCompanyCode}-${Date.now()}`
  }

  updateBooking (booking) {
    this.booking = booking
  }

  updateMessageContext (messageContext = {}) {
    const bookingData = {}
    if (this.booking) {
      bookingData.bookingReference = this.booking.bookingReference
      bookingData.bookingType = this.booking.bookingType
    }

    Object.assign(messageContext, {
      appSessionId: this.sessionId,
      userType: this.user.isTravelAgent ? 'TA' : this.user.whitelabel ? 'WL' : 'CD',
      agencyId: this.user.agencyId,
      consultantId: this.user.travelConsultantId,
      bookingEngineVariant: document.querySelector('.day-tour-flow') ? 'day-tour-flow' : 'default',
    }, bookingData)

    return messageContext
  }

  info (message, messageContext) {
    datadogLogs.logger.info(`[${this.sessionId}] ${message}`, this.updateMessageContext(messageContext))
  }

  warn (message, messageContext) {
    datadogLogs.logger.warn(`[${this.sessionId}] [WARN] ${message}`, this.updateMessageContext(messageContext))
  }

  error (message, messageContext) {
    datadogLogs.logger.error(`[${this.sessionId}] [ERROR] ${message}`, this.updateMessageContext(messageContext))
  }
}
